<!-- Default Our Hosts -->
<div 
    class="hosts-area pt-100 pb-75"
>
    <div class="container" *ngIf="data">
        <div class="section-title d-flex align-items-center justify-content-between">
            <h2 class="heading-title">Nos intervenants</h2>
            <a routerLink="/meet-our-hosts">Découvrir tous nos intervenants <i class="ri-arrow-right-s-line"></i></a>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6" *ngFor="let content of data.slice(0, 4)">
                <div class="single-hosts-card">
                    <div class="hosts-image">
                        <img [src]="content.attributes.speaker_image.data.attributes.url" alt="host-image">
                    </div>
                    <div class="hosts-content">
                        <h3>{{content.attributes.name}}</h3>
                        <span>{{content.attributes.speaker_job}}</span>
                    </div>
                    <ul class="hosts-social">
                        <li>
                            <a href="https://facebook.com/" target="_blank">
                                <i class="flaticon-facebook"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/" target="_blank">
                                <i class="flaticon-twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" target="_blank">
                                <i class="flaticon-instagram"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
